import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { tournamentService } from '@/services/tournament';

export function useTournamentMedalList() {
    const crudAction = useCrudActions();

    const { list, total, fetchList } = useBaseListView({
        request: tournamentService.medal.list
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: tournamentService.medal.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
